import(/* webpackMode: "eager" */ "/tmp/l8-dashboard-v2.2.2/frontend/src/app/(index)/page.tsx");
